import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  termsTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '18px',
  },
  termsText: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '14px',
  },
  termsParagraph: {
    textAlign: 'justify',
  },
}));

interface TermsDialogProps {
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}

function TermsDialog({ open, onClose, onAccept }: TermsDialogProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle className={classes.termsTitle}>
        Términos y Condiciones de Matrícula y Prestación de Servicios Educacionales
        <Typography paragraph>
          Asesorías Educacionales Carez y Córdova S.p.A.
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography paragraph className={classes.termsParagraph}>
          Al completar el pago de matrícula y aceptar el presente documento, el Sostenedor
          declara haber leído y comprendido las condiciones aquí establecidas, y se obliga a
          suscribir el Contrato de Prestación de Servicios Educacionales. Estos términos no
          reemplazan dicho contrato, sino que constituyen un paso previo y necesario
          para su celebración.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          1. Identidad y Facultades.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El Sostenedor declara ser mayor de edad y contar con facultades suficientes para
          obligarse en nombre propio y, cuando corresponda, en representación del estudiante.
          Si el estudiante es menor de edad, el Sostenedor declara actuar con las
          autorizaciones legales necesarias.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          2. El pago de la Matrícula.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El monto pagado por concepto de matrícula quedará, desde este momento,
          reservado a favor del Preuniversitario y tendrá el carácter de no reembolsable.
          Lo anterior se justifica en que el Preuniversitario se obliga a mantener
          reservado un cupo en el(los) horario(s) escogido(s) hasta el inicio de las clases.
          Asimismo, el pago de la matrícula no garantiza por sí solo la incorporación a clases.
          Para ello, el Sostenedor deberá, además, suscribir el contrato respectivo y acreditar
          el pago íntegro del arancel con anterioridad al inicio de las clases.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          3. Compromiso de Pago del Arancel.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El Sostenedor se obliga al pago íntegro del arancel en las fechas establecidas en el
          plan de estudios, independientemente de las inasistencias del estudiante. El
          incumplimiento de los plazos de pago faculta al Preuniversitario a suspender el acceso
          a clases y a la plataforma, previa notificación por correo electrónico con 48 horas de
          anticipación, sin que ello exima al Sostenedor de su obligación de pago.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          4. Política de Devoluciones.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Las solicitudes de retiro y devolución parcial del arancel correspondientes a programas
          anuales serán admitidas únicamente hasta el 30 de junio de 2026. El monto a devolver se
          calculará de manera proporcional, considerando exclusivamente los meses completos no
          cursados.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Con posterioridad a dicha fecha, no procederán devoluciones bajo ninguna circunstancia,
          salvo en casos de fuerza mayor debidamente acreditados, los cuales serán evaluados y
          resueltos discrecionalmente por el Preuniversitario.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          En ningún caso procederá la devolución del monto pagado por concepto de matrícula,
          salvo en la excepción establecida en la cláusula 2.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          5. Uso de la Plataforma y Material Académico.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El acceso a la plataforma educativa es personal, exclusivo e intransferible. El
          material académico, ya sea en formato digital disponible en la plataforma o en
          formato impreso entregado en sede, se encuentra destinado única y exclusivamente
          al uso personal del estudiante.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Se prohíbe expresamente la descarga, reproducción, distribución, captura de imágenes,
          fotografía, escaneo o cualquier otra forma de copia, total o parcial, del material,
          tanto en formato digital como físico.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El incumplimiento de lo anterior facultará al Preuniversitario para suspender o bloquear
          el acceso a la plataforma, sin perjuicio de ejercer las acciones legales correspondientes
          por infracción a los derechos de autor de los cuales es titular.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          6. Asistencia y Convivencia.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El estudiante se obliga a asistir de manera regular y oportuna a las clases programadas,
          así como a cumplir íntegramente las disposiciones contenidas en el Manual de Convivencia,
          el cual se encuentra disponible de forma permanente en la plataforma institucional.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El incumplimiento de dichas obligaciones facultará al Preuniversitario para aplicar las
          medidas disciplinarias que correspondan, de conformidad a su normativa interna, pudiendo
          incluso disponer el término de la calidad de alumno regular.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          7. Protección de Datos Personales.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Los datos personales proporcionados serán tratados de conformidad con lo dispuesto en la
          Ley N°19.628 sobre Protección de la Vida Privada, y serán utilizados exclusivamente para
          fines educacionales, administrativos y de comunicación institucional.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Dichos datos no serán cedidos a terceros sin el consentimiento expreso de su titular,
          salvo en los casos en que exista una obligación legal que así lo exija.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Para consultas o para el ejercicio de los derechos de acceso, rectificación, cancelación
          u otros que la ley confiere, el Sostenedor podrá dirigirse a la sede correspondiente a
          través de los canales oficiales de contacto.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          8. Limitación de Responsabilidad.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          El Preuniversitario no garantiza resultados académicos específicos ni el ingreso del
          estudiante a una institución de educación superior, toda vez que dichos resultados no
          dependen exclusivamente de la formación impartida.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          En consecuencia, el servicio contratado constituye una obligación de medios y no de
          resultado, comprometiéndose el Preuniversitario a otorgar los recursos pedagógicos
          y académicos necesarios conforme a sus estándares, sin asegurar un resultado determinado.
        </Typography>
        <Typography paragraph className={classes.termsText}>
          9. Aceptación.
        </Typography>
        <Typography paragraph className={classes.termsParagraph}>
          Al aceptar los presentes términos, el Sostenedor declara haber leído, comprendido y
          aceptado íntegramente todas las condiciones aquí establecidas, obligándose a suscribir
          el Contrato de Prestación de Servicios Educacionales dentro de los plazos que el
          Preuniversitario determine.
        </Typography>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cerrar
        </Button>
        <Button
          onClick={onAccept}
          variant="contained"
          color="primary"
        >
          Acepto los términos
        </Button>
      </DialogActions>
    </Dialog >
  );
}

export default TermsDialog;
